import * as React from "react";
import System from "src/helper/system";
import Helper from "src/support/Helper";
import ShowMoreLess from "./ShowMoreLess";

const DisplayDescriptionAndManufacturerName = (props) => {
  const { currentProduct, inventory_alert_popup, no_show_more } = props;
  return (
    <>
      {currentProduct &&
        (currentProduct.manufacturerName) && (
          <>

            <div className="text-black-stone cursor-default">
              <div className="d-inline text-wrap w-auto">by&nbsp;</div>
              <a
                href={`/${System.siteName()}/manufacturers/m/${currentProduct?.manufacturerName?.toLowerCase()
                  .replace(/\+/g, "and")
                  .replace(/\&/g, "and")
                  .replace(/\./g, "")
                  .replace(/\//g, "-")
                  .replace(/\,/g, "")
                  .replace(/\s/g, "-")
                  .replace(/\---/g, "-")}`}
                className="text-blue text-break cursor-pointer"
                title={currentProduct.manufacturerName}
              >
                {currentProduct.manufacturerName}
              </a>
            </div>

            {inventory_alert_popup === undefined &&
              currentProduct.ShortDescription ? (
                <>
                  <div className="summary more_summary mt-0 cursor-default">
                    <ShowMoreLess
                      single_product={currentProduct}
                      no_show_more={no_show_more}
                    />
                  </div>
                </>
              ) : (
                ""
              )}
          </>
        )}
    </>
  );
};

export default DisplayDescriptionAndManufacturerName;
